;(function() {
/* @ngInject */
function ModalConfirmFactory($uibModal, $rootScope) {
  let title;
  let message;
  let confirm;
  let cancel;
  let underYes;
  let underNo;
  return function init(title_, message_, confirm_, cancel_, underYes_, underNo_) {
    title = title_;
    message = message_;
    confirm = confirm_;
    cancel = cancel_;
    underYes = underYes_;
    underNo = underNo_;
    return { add };
  };

  function open(options = {}) {
    return $uibModal.open({
      templateUrl: "/app/shared/modal-confirm/modal-confirm-view.html",
      controller: "ModalConfirmController",
      controllerAs: "vm",
      bindToController: true,
      resolve: {
        title: () => title,
        message: () => message,
        confirm: () => confirm,
        cancel: () => cancel,
        underYes: () => underYes,
        underNo: () => underNo
      }
    });
  }

  function add(scope = {}) {
    return open({ scope: angular.extend($rootScope.$new(true), scope)})
  }
}

/* @ngInject */
function ModalConfirmController(title, message, confirm, cancel, underYes, underNo, $uibModalInstance) {
  let vm = this;

  vm.title = title;
  vm.message = message;
  vm.confirm = confirm;
  vm.cancel = cancel;
  vm.underYes = underYes;
  vm.underNo = underNo;

  vm.close = () => {
    $uibModalInstance.close("cancel");
  };

  vm.submit = () => {
    $uibModalInstance.close("confirm");
  };
}

angular.module("firmaren")
  .factory("ModalConfirmFactory", ModalConfirmFactory)
  .controller("ModalConfirmController", ModalConfirmController);
}());
